import { NgModule } from '@angular/core';
import { SharedModule } from '@shared/shared.module';

import { FccpLayout } from './fccp-layout';
import { Fccphome } from './home/fccp-home';
import { FccpLogin } from './login/fccp-login';
import{ FccpRegisteration } from './registeration/fccp-registeration';
import{ FccpVerification } from './verification/fccp-verification';

export const fccppages =  [FccpLayout, Fccphome, FccpLogin,FccpRegisteration,FccpVerification];

